import { Service } from '@onlog-public/additional-services-types';
import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';
import { v4 } from 'uuid';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import getServiceIncludeState from '../../../getServiceIncludeState';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * VariantSelectedServicesProcessor формирует список выбранных услуг по установочным и загруженным
 */
export class VariantSelectedServicesProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    services: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const variantSelectedServices: { [T in string]: string[] } = {};
    const servicesByDir: { directoryID: string; services: Service[] }[] = [];

    const alreadySelectedServiceIds = services.map((service) => service.ServiceData.id);

    Object.entries(additionalServiceState.VariantServices).forEach(([dirId, services]) => {
      servicesByDir.push({ directoryID: dirId, services });
    });

    servicesByDir.map((r) => {
      r.services.map((s) => {
        if (!variantSelectedServices[r.directoryID]) {
          variantSelectedServices[r.directoryID] = [];
        }

        if (getServiceIncludeState(s) || alreadySelectedServiceIds.includes(s.id)) {
          variantSelectedServices[r.directoryID].push(s.id, ...s.additionServices.map((s) => s.id));
        }
      });
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantSelectedServices: variantSelectedServices,
        SelectedProductUUID: v4(),
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
